import React from 'react'
import { FaAddressCard, FaPhone, FaEnvelope } from "react-icons/fa"

const Contact = () => (
    <section id="contact" className="container py-12">
        <div className="flex flex-col justify-between lg:flex-row">
            <div className="flex-1 mr-0 lg:mr-4">
            <form name="contact" method="POST" data-netlify="true">
                <input type="hidden" name="form-name" value="contact" />
                <input type="text" name="name" placeholder="Name" required/>
                <input type="email" name="email" placeholder="Email address" required/>
                <textarea type="text" name="message" placeholder="Project details" required/>
                <button type="submit" className="btn-cta">Send</button>
            </form>
            </div>
            <div className="flex-1">
                <div className="w-full px-8 py-6 mb-6 ml-0 text-xl text-white rounded shadow-2xl lg:ml-4 bg-gradient">
                    <FaAddressCard className="inline-block mr-2 text-2xl align-text-top" /> 511  Jarvisville Road, Lansing, MI.
                </div>
                <div className="w-full px-8 py-6 mx-0 mb-6 text-xl text-white rounded shadow-2xl lg:mx-4 bg-gradient">
                    <FaPhone className="inline-block mr-2 text-2xl align-text-top" /> 517-881-0769
                </div>
                <a href="mailto:me@khaledelbalal.me">
                    <div className="w-full px-8 py-6 mx-0 mb-6 text-xl text-white rounded shadow-2xl lg:mx-4 bg-gradient">
                        <FaEnvelope className="inline-block mr-2 text-2xl align-text-top" /> me@patric.com
                    </div>
                </a>
            </div>
        </div>
    </section>
)

export default Contact